import * as React from 'react';
import './form-hint.scss';
import type { DataAttributes } from '../../../modules/react-utils';
import cn from '~modules/cn';

type FormHintProps = {
    status?: 'error' | 'success';
    spacer?: 'top' | 'bottom';
    className?: string;
    children: React.ReactNode;
} & DataAttributes;

type Props = FormHintProps;

const FormHint = ({ className, status, children, spacer = 'top', ...rest }: Props): JSX.Element => (
    <div
        {...rest}
        className={cn('form-hint', className, `form-hint--spacer-${spacer}`, {
            [`form-hint--${status}`]: status
        })}
    >
        {children}
    </div>
);

export default FormHint;
